import { Component, OnInit } from '@angular/core';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { UserDao } from '@app/dao/user/user.dao';
import { Subject } from 'rxjs';
import { EaAssetsFormService } from './ea-assets-form.service';
import { AssetTypeService } from '@app/services/asset-type.service';
import { AssetCategory } from '@app/models/assetCategory';
import { AssetTypeOption } from '@app/models/assetTypeOption';

@Component({
    selector: 'ea-assets-form',
    templateUrl: './ea-assets-form.component.html',
    styleUrls: ['./ea-assets-form.component.scss'],
    standalone: false
})
export class EaAssetsFormComponent extends PrFormAbstract implements OnInit {
  users: any[];
  countries: any[] = [];
  personalUseType: any[] = [];
  subscriptionSource: any[] = [];
  doneSubject: Subject<void> = new Subject<void>();

  categories: AssetCategory[];
  expandedCategoryId: string | null = null;
  selectedCategoryOptions: AssetTypeOption[] = [];
  animatingOptions: boolean = false;

  constructor(
    protected formContructor: PrFormConstructor,
    protected userDao: UserDao,
    protected assetsFormService: EaAssetsFormService,
    protected assetTypeService: AssetTypeService,
  ) {
    super(formContructor);
  }

  get title() {
    return this.entity && this.entity.label
      ? this.entity.label
      : 'Nouveau bien';
  }

  ngOnInit() {
    if (this.entity.type) {
      let category = this.assetTypeService.getCategoryById(this.entity.type);
      if (category) this.selectCategory(category);

      let assetType = this.assetTypeService.getAssetTypeOptionById(
        this.entity.type,
      );
      if (assetType) this.selectAssetType(assetType);
    }
    this.categories = this.assetTypeService.getCategories();
  }

  /**
   * Gère le clic sur une catégorie
   */
  selectCategory(category: AssetCategory): void {
    // Si on clique sur la même catégorie, on la ferme
    if (this.expandedCategoryId === category.id) {
      this.animatingOptions = false;
      setTimeout(() => {
        this.expandedCategoryId = null;
        this.selectedCategoryOptions = [];
      }, 100);
      return;
    }

    // Ouvre la nouvelle catégorie
    this.expandedCategoryId = category.id;
    this.selectedCategoryOptions =
      this.assetTypeService.getTypeOptionsFromCategoryId(category.id);

    // Déclenche l'animation après un petit délai
    setTimeout(() => {
      this.animatingOptions = true;
    }, 50);

    // Si aucune option n'est disponible, on accède directement au formulaire
    if (this.selectedCategoryOptions.length === 0) {
      this.accessFormDirectly(category);
    }
  }

  /**
   * Gère le clic sur un type d'actif spécifique
   */
  selectAssetType(assetType: AssetTypeOption): void {
    this.selectType(assetType.id, assetType.form);
  }

  isCategoryExpanded(categoryId: string): boolean {
    return this.expandedCategoryId === categoryId;
  }

  /**
   * Accès direct au formulaire quand il n'y a pas d'options
   */
  accessFormDirectly(category: AssetCategory): void {
    this.selectType(category.id, category.form);
  }

  selectType(type, formType) {
    this.userDao.authOnce$().subscribe(user => {
      let entity = {
        ...this.entity,
        userId: user.id,
        accountId: user.accountId,
        type: type,
      };

      entity.type = type;

      this.prFormService.trigger(formType, entity);
    });
  }

  public generate = () => this.assetsFormService.generate(this.entity);
  public extract = () => this.assetsFormService.extract(this.form);
  public submit = () => super.submit();

  onSubmit() {}
}
